<template>
  <div class="tcla-product-links">
    <div class="tcla-cards-row">
      <div class="tcla-mini-card">
        <div class="tcla-mini-card__value">{{ productLinkAnalysis.products.length }}</div>
        <div class="tcla-mini-card__label">کل محصولات</div>
      </div>
      <div class="tcla-mini-card tcla-mini-card--danger">
        <div class="tcla-mini-card__value">{{ productLinkAnalysis.orphanProducts.length }}</div>
        <div class="tcla-mini-card__label">محصول بدون لینک از مقاله</div>
      </div>
      <div class="tcla-mini-card tcla-mini-card--warn">
        <div class="tcla-mini-card__value">{{ productLinkAnalysis.articlesWithNoProductLinks.length }}</div>
        <div class="tcla-mini-card__label">مقاله بدون لینک به محصول</div>
      </div>
      <div class="tcla-mini-card">
        <div class="tcla-mini-card__value">{{ productLinkAnalysis.suggestions.length }}</div>
        <div class="tcla-mini-card__label">پیشنهاد لینک جدید</div>
      </div>
    </div>

    <div v-if="productLinkAnalysis.products.length === 0" class="tcla-panel">
      <div class="tcla-empty">
        هیچ محصولی شناسایی نشد. صفحاتی که آدرس‌شان با «/product» شروع می‌شود
        به‌عنوان محصول در نظر گرفته می‌شوند (قابل تنظیم).
      </div>
    </div>

    <template v-else>
      <div class="tcla-panel">
        <h3 class="tcla-panel__title tcla-section__title--err">🚫 محصولات بدون لینک از مقاله</h3>
        <p class="tcla-panel__hint">این محصولات هیچ ترافیک داخلی از مقالات دریافت نمی‌کنند.</p>
        <div v-if="productLinkAnalysis.orphanProducts.length === 0" class="tcla-empty">🎉 همه‌ی محصولات حداقل یک لینک از مقاله دارند</div>
        <div v-for="p in productLinkAnalysis.orphanProducts" :key="p.url" class="tcla-product-card">
          <strong>{{ p.title }}</strong>
          <span v-if="p.category" class="tcla-tag tcla-tag--blue">{{ p.category }}</span>
        </div>
      </div>

      <div class="tcla-panel">
        <h3 class="tcla-panel__title">💡 پیشنهاد لینک مقاله ← محصول</h3>
        <p class="tcla-panel__hint">بر اساس اشتراک دسته‌بندی/برچسب بین مقاله و محصول.</p>
        <div v-if="productLinkAnalysis.suggestions.length === 0" class="tcla-empty">پیشنهادی یافت نشد.</div>
        <div v-for="(s, i) in productLinkAnalysis.suggestions" :key="i" class="tcla-suggestion-card">
          <div class="tcla-suggestion-card__titles">
            <strong>{{ s.articleTitle }}</strong>
            <span class="tcla-arrow">←</span>
            <strong>{{ s.productTitle }}</strong>
          </div>
          <div class="tcla-suggestion-card__reason">{{ s.reason }}</div>
          <button class="tcla-btn" @click="$emit('edit-blog', s.articleSource)">ویرایش مقاله</button>
        </div>
      </div>

      <div class="tcla-panel">
        <h3 class="tcla-panel__title tcla-section__title--warn">📄 مقالاتی که به هیچ محصولی لینک نمی‌دهند</h3>
        <div v-if="productLinkAnalysis.articlesWithNoProductLinks.length === 0" class="tcla-empty">🎉 همه‌ی مقالات حداقل به یک محصول لینک می‌دهند</div>
        <div v-for="a in productLinkAnalysis.articlesWithNoProductLinks" :key="a.url" class="tcla-product-card">
          <strong>{{ a.title }}</strong>
          <button class="tcla-btn" @click="$emit('edit-blog', a.source)">ویرایش</button>
        </div>
      </div>

      <div class="tcla-panel">
        <h3 class="tcla-panel__title">📦 وضعیت همه‌ی محصولات</h3>
        <div class="tcla-score-table">
          <div class="tcla-score-row tcla-score-row--head">
            <span>محصول</span><span>لینک ورودی از مقالات</span>
          </div>
          <div v-for="p in productLinkAnalysis.products" :key="p.url" class="tcla-score-row">
            <span class="tcla-score-row__title">{{ p.title }}</span>
            <span class="tcla-score-pill" :class="p.incomingCount > 0 ? 'tcla-score--good' : 'tcla-score--bad'">{{ p.incomingCount }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TCLAProductLinks',
  props: {
    productLinkAnalysis: {
      type: Object,
      default: () => ({ products: [], orphanProducts: [], articlesWithNoProductLinks: [], suggestions: [] })
    }
  }
};
</script>

<style scoped>
.tcla-cards-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.tcla-mini-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 14px;
  text-align: center;
}
.tcla-mini-card__value { font-size: 1.4rem; font-weight: 700; color: #1f2937; }
.tcla-mini-card__label { font-size: 0.72rem; color: #9ca3af; margin-top: 4px; }
.tcla-mini-card--danger .tcla-mini-card__value { color: #ef4444; }
.tcla-mini-card--warn .tcla-mini-card__value { color: #f59e0b; }

.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
  margin-bottom: 16px;
}
.tcla-panel__title { font-size: 0.92rem; font-weight: 700; margin: 0 0 6px 0; }
.tcla-section__title--err { color: #ef4444; }
.tcla-section__title--warn { color: #d97706; }
.tcla-panel__hint { font-size: 0.78rem; color: #9ca3af; margin: 0 0 14px 0; }
.tcla-empty { text-align: center; padding: 16px; color: #9ca3af; font-size: 0.85rem; }

.tcla-product-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #fecaca;
  background: #fef2f2;
  border-radius: 0.5rem;
  padding: 10px 14px;
  margin-bottom: 8px;
  font-size: 0.85rem;
}

.tcla-suggestion-card {
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  border-radius: 0.5rem;
  padding: 12px 14px;
  margin-bottom: 10px;
}
.tcla-suggestion-card__titles {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  flex-wrap: wrap;
}
.tcla-arrow { color: #9ca3af; }
.tcla-suggestion-card__reason {
  font-size: 0.76rem;
  color: #6b7280;
  margin: 6px 0 10px;
}

.tcla-score-table { display: flex; flex-direction: column; gap: 2px; font-size: 0.82rem; }
.tcla-score-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid #f3f4f6;
}
.tcla-score-row--head { font-weight: 700; color: #9ca3af; font-size: 0.7rem; }
.tcla-score-row__title { text-align: right; }
.tcla-score-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.72rem;
  text-align: center;
}
.tcla-score--good { background: #d1fae5; color: #16a34a; }
.tcla-score--bad { background: #fee2e2; color: #ef4444; }

.tcla-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  margin-right: 6px;
}
.tcla-tag--blue { background: #dbeafe; color: #3b82f6; }

.tcla-btn {
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.78rem;
  cursor: pointer;
}
.tcla-btn:hover { background: #f3f4f6; }
</style>
